<template>
  <div
    :class="{
      [$style.textSlide]: true,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone
    }"
  >
    <!-- ICON -->
    <div :class="$style.iconBox">
      <img :src="getImg" alt="email icon" />
    </div>
    <!-- HEADING -->
    <h1 :class="$style.heading">Wie geht es jetzt weiter?</h1>
    <!-- TEXT -->
    <div :class="$style.textBox">
      <p :class="$style.paragraph">
        {{
          isNewDesign
            ? 'Sie erhalten in Kürze eine E-Mail. Bitte bestätigen Sie diese, damit wir Ihre Anfrage bearbeiten können.'
            : 'Sie erhalten in Kürze eine E-Mail.'
        }}
      </p>
      <p :class="$style.paragraph" v-if="!isNewDesign">
        <span :class="$style.boldText">Bitte bestätigen Sie diese</span>, damit
        wir Ihre Anfrage bearbeiten können.
      </p>
      <p :class="$style.paragraph" v-else>
        Hinweis: Bitte prüfen Sie auch den Spam Ordner.
      </p>
      <p :class="$style.paragraph">
        {{
          isNewDesign
            ? 'Wichtig für Sie zur Info:'
            : 'Hinweis: Bitte prüfen Sie auch den Spam Ordner.'
        }}
      </p>
      <p :class="$style.paragraph" v-if="isNewDesign">
        Als Premium-Partner reichen wir Ihre Angebotsanfrage für Sie bei der
        Deutsche Teilkauf GmbH ein - Sie müssen dort also kein gesondertes
        Angebot anfragen.
      </p>
    </div>
  </div>
</template>

<script>
import store from '@/store'

export default {
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    getImg() {
      // note: newDesign
      if (this.isNewDesign) {
        return require('../../assets/images/Email_new.svg')
      } else {
        return require('../../assets/images/email.svg')
      }
    },
    el() {
      return store.state.el
    }
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';
@import '@/scss/animations.scss';

.textSlide {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: $color_font_2;
  text-align: left;
  line-height: 1.2;
  max-width: 450px;
}

.iconBox {
  height: 54px;
  width: 54px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding-right: 50px;
  margin-bottom: 20px;
}

.heading {
  font-size: 34px;
  font-weight: 400;
  margin-bottom: 25px;
  line-height: 1.2;
}

.textBox {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;
  font-weight: 500;
  font-size: 18px;

  .paragraph {
    margin-bottom: 20px;
    .boldText {
      font-weight: 700;
    }
  }
}

// note: port

// note: phone
.phone {
  &.textSlide {
    max-width: 100%;
    width: 100%;
    font-weight: 500;
    .iconBox {
      width: 100%;
      display: flex;
      justify-content: center;
      padding-right: 0px;
      margin-bottom: 20px;
    }
    .heading {
      margin-bottom: 26px;
      font-size: 26px;
      font-weight: 500;
      text-align: center;
      width: 100%;
    }
  }
}
</style>
